import script from "./ToastOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastOverlay.vue?vue&type=script&setup=true&lang=js"

import "./ToastOverlay.vue?vue&type=style&index=0&id=471fa368&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/set-repository-web-glasses/glasses-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-471fa368"]])

export default __exports__